import styled from 'styled-components';
import Inset from 'syf-component-library/ui/spacing/Inset/Inset';
import query from 'syf-component-library/const/mediaQueries';
import { H5 } from 'syf-component-library/ui/typography';
import { colors, fontWeights, spacing } from 'syf-component-library/defaultTheme';
export const UserItemWrapper = styled(Inset) `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: ${({ isNewUserConfirmation }) => isNewUserConfirmation ? 'inherit' : `2px solid ${colors.lightestGrey}`};
`;
export const NewUserItemWrapper = styled(Inset) `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const UserListTitle = styled(H5) `
  border-bottom: 1px solid ${colors.lightGrey};
  font-weight: ${fontWeights.light};
  font-family: inherit;
`;
export const UserListWrapper = styled(Inset) `
  display: flex;
  flex-direction: column;
  width: 90%;
  margin-inline: auto;
  flex: 2;
`;
export const UserGroup = styled.div `
  display: flex;
  align-items: center;
`;
export const NoManageCardHoldersAddedContainer = styled(Inset) `
  text-align: center;

  @media ${query.lessThanMedium} {
    width: 90%;
    margin-inline: auto;
  }
`;
export const NoteWrapper = styled(Inset) `
  background-color: ${colors.lightestGrey};
  margin: ${spacing.medium}px auto;
  width: 100%;
`;
